(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spot"] && !Shopify.designMode) return;
  try {
    
window.spotSetup = function(preferences, productRenderer, recommendationsRenderer) {
	var sortBy = document.querySelector(preferences.sortBySelector || 'select[name="sort_by"]');
	if (sortBy && preferences.sortByRemoval) {
		var sortByOld = sortBy;
		sortBy = sortBy.cloneNode(true);
		sortByOld.parentNode.replaceChild(sortBy, sortByOld);
	}
	if (preferences.searchRemoval) {
		window.addEventListener('load', function() {
			var searchBars = document.querySelectorAll('input[name="q"]');
			searchBars.forEach(function(searchBar) {
				searchBarNew = searchBar.cloneNode(true);
				searchBar.parentNode.replaceChild(searchBarNew, searchBar);
			});
		});
	}
	var productContainer = preferences.productSelector ? document.querySelector(preferences.productSelector) : null;
	var facetPaneContainer = preferences.facetPaneSelector ? document.querySelector(preferences.facetPaneSelector) : null;
	var recommendationsPaneContainer = preferences.recommendationsPaneSelector ? document.querySelector(preferences.recommendationsPaneSelector) : null;
	var facetPaneSelectorPosition = preferences.facetPaneSelectorPosition;
	var recommendationsPaneSelectorPosition = preferences.recommendationsPaneSelectorPosition;
	var paginationContainers = [];
	var facetPaneOptions = {
		includeSorting: preferences.sortingType == "facet",
		hideInactiveFacetValues: preferences.hideInactiveFacetValues,
		hideInactiveFacets: preferences.hideInactiveFacets,
		classes: []
	};
	var recommendationOptions = {
		renderer: recommendationsRenderer,
		classes: []
	};
	if (!preferences.breadcrumbs || preferences.breadcrumbSelector)
		facetPaneOptions['breadcrumbs'] = preferences.breadcrumbSelector ? document.querySelector(preferences.breadcrumbSelector) : false;
	var themeSpecificInit = function() { };
	var isSearchPage = /\/search/.test(window.location.pathname);
	
	

	if (preferences.paginationSelector)
		paginationContainers = document.querySelectorAll(preferences.paginationSelector);
	if (preferences.facetColorSwatches)
		facetPaneOptions['classes'].push('swatches');
	if (preferences.facetCollapsible == "auto")
		preferences.facetCollapsible = preferences.facetOrientation == "horizontal" ? "single" : "never";

	facetPaneOptions['classes'].push(preferences.facetOrientation, "theme-klauss-enterprise-main", "collapsible-" + preferences.facetCollapsible, "styling-"  + preferences.facetStyling);
	var collapseActiveFacets = preferences.facetCollapsible == "manual" || preferences.facetCollapsible == "single";
	if (preferences.facetCollapsible == "single" || preferences.facetCollapsible == "active" || preferences.facetCollapsible == "visible")
		facetPaneOptions['classes'].push("collapsible");
	facetPaneOptions['singleActive'] = preferences.facetCollapsible == "single";
	facetPaneOptions['collapsible'] = preferences.facetCollapsible;

	recommendationOptions['classes'].push("theme-klauss-enterprise-main");

	var deferred = SpotDefault.init({
		init: function(spotAPI, spotDOM, spotDefault) {
			
			if (preferences.omitUnavailable)
				spotAPI.defaultQuery(spotAPI.s().available(true));
			spotDOM.optionBehavior(preferences.facetCount);
			spotDOM.autoCorrect(preferences.autoCorrect);
			spotDOM.paginate(preferences.resultsPerPage);
			themeSpecificInit(spotAPI, spotDOM, spotDefault);
		},
		
		facetPaneOptions: facetPaneOptions,
		searchBarOptions: {
			maxProducts: preferences.instantSearchResultsPerPage,
			showAll: preferences.instantSearchShowAll,
			alwaysDropdown: !preferences.instantSearchBehavior || preferences.instantSearchBehavior == "independent",
			deferHookUntilLoad: preferences.searchRemoval
		},
		rule: preferences.rule,
		paginationType: preferences.paginationType,
		searchBars: preferences.instantSearch == "disabled" ? [] : undefined,
		clusters: preferences.clusters,
		settings: preferences.settings,
		companyLocationId: preferences.companyLocationId,
		eventSink: preferences.eventSink,
		defaultSortOrder: preferences.defaultSortOrder,
		moneyFormat: preferences.moneyFormat,
		currentCount: preferences.currentCount,
		productContainer: productContainer,
		sortDropdown: sortBy,
		omitExtraneousResults: preferences.omitExtraneousResults,
		paginationContainers: paginationContainers,
		facetPaneContainer: facetPaneContainer,
		facetPaneContainerSelectorPosition: facetPaneSelectorPosition != "auto" ? facetPaneSelectorPosition : null,
		recommendationsPaneContainer: recommendationsPaneContainer,
		recommendationsPaneContainerSelectorPosition: null,
		recommendationsPaneOptions: recommendationOptions,
		productRenderer: productRenderer,
		product: preferences.product,
		productSettings: preferences.productSettings,
		products: preferences.products,
		all_tags: preferences.all_tags
	});
	if (collapseActiveFacets)
		document.querySelectorAll('.facet.active').forEach(function(e) { e.classList.remove("active"); });
	return deferred;
};

  } catch(e) { console.error(e); }
})();
})();
